import type { QuestionResponseFlow } from "../../contracts";
import type { QuestionHost } from "./types";

const hostResponseFlows = {
  chat: "stepwise",
  forms: "all-at-once",
} satisfies Record<QuestionHost, QuestionResponseFlow>;

export const preferredResponseFlow = (
  host: QuestionHost,
): QuestionResponseFlow => hostResponseFlows[host];
